(function (root, factory) {
	'use strict';

	if (typeof define === 'function' && define.amd) {
		// AMD
		define([], factory);
	} else if (typeof exports === 'object') {
		// Node, CommonJS-like
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.s5Utils = factory();
	}
}(this, function () {
	'use strict';

	/**
	 * Utilities
	 * Some good to have functions/helpers that works without jquery.
	 * @see {@link http://youmightnotneedjquery.com/}
	 * @version 2.0.2
	 * @exports utilities
	 */
	var utilities = {

		/**
		 * forEach function.
		 * @param {Object} arr - An array.
		 * @param {Object} fn - A function to be performed on each array item.
		 * @public
		 */
		forEach: function (arr, fn) {
			for (var i = 0; i < arr.length; i++) {
				fn(arr[i], i);
			}
		},


		/**
		 * forEach element function.
		 * @param {String} selector - A selector as a string.
		 * @param {Object} fn - A function to be performed on each DOM node that match the selector.
		 * @public
		 */
		forEachElement: function (selector, fn) {
			var elements = document.querySelectorAll(selector),
				i;

			for (i = 0; i < elements.length; i++) {
				fn(elements[i], i);
			}
		},


		/**
		 * Get the browser to rerender.
		 * @param {String} browser - A class-name from the html-tag that defines a browser (eg 'lt-ie9', 'lt-ie8').
		 * @public
		 */
		rerenderElement: function (browser) {
			if (browser === undefined || (browser !== undefined && this.hasClass(document.documentElement, browser))) {
				document.body.className = document.body.className;
			}
		},


		/**
		 * Detects if an element has a certain class.
		 * @param {Object} el - A DOM node.
		 * @param {String} className - The classname to test.
		 * @public
		 */
		hasClass: function (el, className) {
			if (el.classList) {
				return el.classList.contains(className);
			} else {
				return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
			}
		},


		/**
		 * Adds a class to an element.
		 * @param {Object} el - A DOM node.
		 * @param {String} className - The classname to add.
		 * @public
		 */
		addClass: function (el, className) {
			if (el.classList) {
				el.classList.add(className);
			} else {
				el.className += ' ' + className;
			}
		},


		/**
		 * Removes a class from an element.
		 * @param {Object} el - A DOM node.
		 * @param {String} className - The classname to remove.
		 * @public
		 */
		removeClass: function (el, className) {
			if (el.classList) {
				el.classList.remove(className);
			} else {
				el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		},


		/**
		 * Adds an event listener to an element.
		 * @param {Object} el - A DOM node.
		 * @param {String} eventName - An event name.
		 * @param {Object} handler - A function to be called when event fires.
		 * @public
		 */
		addEventListener: function (el, eventName, handler) {
			if (el.addEventListener) {
				if (eventName === 'focus' || eventName === 'blur') {
					el.addEventListener(eventName, handler, true);
				} else {
					el.addEventListener(eventName, handler);
				}
			} else {
				el.attachEvent('on' + eventName, function () {
					handler.call(el);
				});
			}
		},


		/**
		 * Removes an event listener from an element.
		 * @param {Object} el - A DOM node.
		 * @param {String} eventName - An event name.
		 * @param {Object} handler - The function that is called when event fires.
		 * @public
		 */
		removeEventListener: function (el, eventName, handler) {
			if (el.removeEventListener) {
				el.removeEventListener(eventName, handler);
			} else {
				el.detachEvent('on' + eventName, handler);
			}
		},


		/**
		 * Removes a DOM node.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		remove: function (el) {
			if (el.remove) {
				el.remove();
			} else {
				el.parentNode.removeChild(el);
			}
		},


		/**
		 * Extends/mixes two or more objects.
		 * @param {...Object} Two of more objects.
		 * @public
		 */
		extend: function () {
			for (var i = 1; i < arguments.length; i++) {
				for (var key in arguments[i]) {
					if (arguments[i].hasOwnProperty(key)) {
						arguments[0][key] = arguments[i][key];
					}
				}
			}
			return arguments[0];
		},


		/**
		 * Removes tags from an html string, except the tags defined in the allow-parameter.
		 * @param {String} html - A string of html.
		 * @param {String} allowed - A string of tags to be allowed (e.g. '<ul><li>').
		 * @public
		 */
		stripTags: function (html, allowed) {
			allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
			var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
				commentTags = /<!--[\s\S]*?-->/gi;

			return html.replace(commentTags, '').replace(tags, function ($0, $1) {
				return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
			});
		},


		/**
		 * Detects if an element is in the viewport.
		 * @param {Object} el - A DOM node.
		 * @see {@link http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433}
		 * @public
		 */
		isElementInViewport: function (el) {
			var rect = el.getBoundingClientRect();

			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		},


		/**
		 * Detects if browser has support for the History API.
		 * @public
		 */
		hasHistorySupport: function () {
			return !!(window.history && history.pushState);
		},


		/**
		 * Returns a timestamp
		 * @public
		 */
		getTimestamp: function () {
			if (!Date.now) {
				return new Date().getTime();
			} else {
				return Date.now();
			}
		},


		/**
		 * DOMParser HTML extension for other browsers.
		 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/DOMParser}
		 * @public
		 */
		domParserPolyfill: function () {
			if (window.DOMParser !== undefined) {
				(function (DOMParser) {
					var proto = DOMParser.prototype,
						nativeParse = proto.parseFromString;

					// Firefox/Opera/IE throw errors on unsupported types
					try {
						// WebKit returns null on unsupported types
						if ((new DOMParser()).parseFromString('', 'text/html')) {
							// text/html parsing is natively supported
							return;
						}
					} catch (ex) {}

					proto.parseFromString = function (markup, type) {
						if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
							var doc = document.implementation.createHTMLDocument('');

							if (markup.toLowerCase().indexOf('<!doctype') > -1) {
								doc.documentElement.innerHTML = markup;
							} else {
								doc.body.innerHTML = markup;
							}

							return doc;
						} else {
							return nativeParse.apply(this, arguments);
						}
					};
				}(DOMParser));
			}
		},


		/**
		 * Polyfill requestAnimFrame.
		 * @see {@link http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/}
		 * @private
		 */
		rafPolyfill: function () {
			window.requestAnimFrame = (function () {
				return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				function (callback) {
					window.setTimeout(callback, 1000 / 60);
				};
			})();
		},


		/**
		 * Parse a form and creates an object with all the keys and values.
		 * @param {Object} form - A FORM DOM node.
		 * @see {@link https://plainjs.com/javascript/ajax/serialize-form-data-into-an-array-46/}
		 * @public
		 */
		formToArray: function (form) {
			var field, l, s = [];

			if (typeof form == 'object' && form.nodeName == 'FORM') {
				var len = form.elements.length;

				for (var i = 0; i < len; i++) {
					field = form.elements[i];
					if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
						if (field.type == 'select-multiple') {
							l = form.elements[i].options.length;
							for (var j = 0; j < l; j++) {
								if (field.options[j].selected) {
									s[s.length] = { name: field.name, value: field.options[j].value };
								}
							}
						}
						else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
							s[s.length] = { name: field.name, value: field.value };
						}
					}
				}
			}

			return s;
		},


		/**
		 * Takes a form and creates a query-string from it's values.
		 * @param {Object} form - A FORM DOM node.
		 * @see {@link module:utilities.formToArray}
		 * @public
		 */
		formToQuery: function (form) {
			var data = this.formToArray(form),
				query = [];

			this.forEach(data, function (obj) {
				query.push(encodeURIComponent(obj.name) + '=' + encodeURIComponent(obj.value));
			});

			return query.join('&');
		},


		/**
		 * Returns the value of an object attribute based of the attribute "path" as an string.
		 * @param {Object} o - A object.
		 * @param {String} s - A string.
		 * @public
		 */
		objectByString: function (o, s) {
			s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
			s = s.replace(/^\./, '');           // strip a leading dot
			var a = s.split('.');
			for (var i = 0, n = a.length; i < n; ++i) {
				var k = a[i];
				if (k in o) {
					o = o[k];
				} else {
					return;
				}
			}
			return o;
		}
	};


	return utilities;
}));


//////////////////
// WEBPACK FOOTER
// ./components/utilities/utilities.js
// module id = 3
// module chunks = 0